import React, {PureComponent} from 'react';
import {Link} from "react-router-dom";
import './index.css'
import {withTranslation} from 'react-i18next';
import Button from "react-bootstrap/Button";
import Loading from '../subComponents/GenericLoading/loading'
import Connect from "react-redux/es/connect/connect";
import {getArticle, getPendingArticles, getScheduledArticles} from "../../actions";

import {
	dispatchOnDashboardClickedArticleIdChanged,
	dispatchOnDashboardGetPendingArticles,
	dispatchOnDashboardGetPendingArticlesFailure,
	dispatchOnDashboardGetPendingArticlesSuccess,
	dispatchOnDashboardGetScheduledArticles,
	dispatchOnDashboardGetScheduledArticlesFailure,
	dispatchOnDashboardGetScheduledArticlesSuccess
} from "./functions";
import BetterGenericTable from "../subComponents/BetterGenericTable";
import {find} from "../../utility/functions";
import {dispatchOnCreateArticlesSetArticleToEditChanged} from "../news/create/article/functions";

class Dashboard extends PureComponent {

	// Native component functions

	componentDidMount() {
		this.onGetPendingArticles();
		this.onGetScheduledArticles();
	}

	// Custom component functions

	// Fetches all the pending articles from the api and dispatches functions to redux according to the result
	onGetPendingArticles = () => {
		this.props.dispatchOnDashboardGetPendingArticles();
		getPendingArticles()
			.then((response) => {
				this.props.dispatchOnDashboardGetPendingArticlesSuccess(response);
			})
			.catch((error) => {
				this.props.dispatchOnDashboardGetPendingArticlesFailure(error);
			})
	};

	// Fetches all the scheduled articles from the api
	onGetScheduledArticles = () => {
		this.props.dispatchOnDashboardGetScheduledArticles();
		getScheduledArticles()
			.then((response) => {
				this.props.dispatchOnDashboardGetScheduledArticlesSuccess(response);
			})
			.catch((error) => {
				this.props.dispatchOnDashboardGetScheduledArticlesFailure(error);
			})
	};

	onGetArticle = (id) => {
		getArticle(id)
			.then(response => {
				this.props.dispatchOnCreateArticlesSetArticleToEditChanged(response.data);
				if (find(response.data, 'images').length > 1) {
					this.props.history.push('/create-news/gallery');
				} else {
					this.props.history.push('/create-news/multimedia');
				}
				this.props.dispatchOnDashboardClickedArticleIdChanged(null);
			})
			.catch(error => {

			})
	};

	// This functions is called when new multimedia or new gallery is button pressed
	// Redirecting the client/user to the appropriate page
	onCreateNewButtonClicked = (redirect) => {
		this.props.history.push(redirect);
	};

	// Native component render function

	render() {
		const {t} = this.props;
		return (
			<div>
				<div className="container-dashboard">
					<div className="container-dashboard-header">
						<h2>Notícias</h2>
					</div>
					<div className="container-dashboard-body">
						<div className="container-dashboard-body-actions">
							<div className={"container-dashboard-body-actions-div-multimedia"}>
								<Button
									className="container-dashboard-body-action-multimedia-new-button"
									onClick={() => this.onCreateNewButtonClicked('/create-news/multimedia')}>
									<div>
										<div className="multimedia-new-button-title">
											<div>
												<div className="multimedia-new-button-title-strong">{t('NEW')}</div>
												<div
													className="multimedia-new-button-title-normal">{t('Multimedia New')}</div>
											</div>
										</div>
										<div className="multimedia-new-button-icon">
											<img alt="news multimedia" src="../../assets/news_multimedia.png"/>
										</div>
									</div>
								</Button>
							</div>
							<div className={"container-dashboard-body-actions-div-gallery"}>
								<Button className="container-dashboard-body-action-gallery-new-button"
								        onClick={() => this.onCreateNewButtonClicked('/create-news/gallery')}>
									<div>
										<div className="gallery-new-button-title">
											<div>
												<div className="gallery-new-button-title-strong">{t('NEW')}</div>
												<div
													className="gallery-new-button-title-normal">{t('Gallery New')}</div>
											</div>
										</div>
										<div className="gallery-new-button-icon">
											<img alt="news multimedia" src="../../assets/news_gallery.png"/>
										</div>
									</div>
								</Button>
							</div>
						</div>
						<div className="container-dashboard-body-tables">
							<div className="container-dashboard-body-table-div">
								<div className="container-dashboard-body-table-header">
									<div className="container-dashboard-body-table-header-title">
										{t('News to approve')}
									</div>
									<div className="container-dashboard-body-table-header-link-div">
										<Link className={"container-dashboard-body-table-header-link"} to="/approve-news">{t('see all')}</Link>
									</div>
								</div>
								<BetterGenericTable
									data={this.props.pendingArticles}
									columns={[
										{
											name: t("Title"),
											value: (item, index) => {
												return find(item, 'title');
											},
											rowClassName: 'table-column-list-articles-title'
										},
										{
											name: t("Author"),
											value: (item, index) => {
												return find(item, 'author');
											},
										}
									]}
									onRowClicked={(row, index) => {
										const id = find(row, 'id')
										this.props.dispatchOnDashboardClickedArticleIdChanged(id);
										this.onGetArticle(id)
									}}
									loading={this.props.loadingPending}
									loadingComponent={(
										<Loading size={"small-spinner"} color={"blue"}/>
									)}
									emptyTableComponent={t("No articles pending")}
									rowContainerClassName={'container-dashboard-body-table-row-container'}
									rowColumnsClassName={'container-dashboard-body-table-row-columns'}
									rowLoading={(row, index) => {
										return find(row, 'id') === this.props.clickedArticleId;
									}}
									rowLoadingComponent={(
										<div className={'container-dashboard-body-table-row-loading-component'}>
											<Loading size={"small-spinner"} color={"blue"}/>
											<div style={{marginLeft: 8}}>Carregando Artigo</div>
										</div>
									)}
								/>
							</div>
							<div className="container-dashboard-body-table-div">
								<div className="container-dashboard-body-table-header">
									<div className="container-dashboard-body-table-header-title">
										{t('Scheduled news')}
									</div>
									<div className="container-dashboard-body-table-header-link-div">
										<Link className={"container-dashboard-body-table-header-link"} to="/manage-news">{t('see all')}</Link>
									</div>
								</div>
								<BetterGenericTable
									data={this.props.scheduledArticles}
									columns={[
										{
											name: t("Title"),
											value: (item, index) => {
												return find(item, 'title');
											},
											rowClassName: 'table-column-list-articles-title'
										},
										{
											name: t("Author"),
											value: (item, index) => {
												return find(item, 'author');
											},
										}
									]}
									loading={this.props.loadingScheduled}
									loadingComponent={(
										<Loading size={"small-spinner"} color={"blue"}/>
									)}
									onRowClicked={(row, index) => {
										const id = find(row, 'id');
										this.props.dispatchOnDashboardClickedArticleIdChanged(id);
										this.onGetArticle(id)
									}}
									emptyTableComponent={t('No articles scheduled')}
									rowContainerClassName={'container-dashboard-body-table-row-container'}
									rowColumnsClassName={'container-dashboard-body-table-row-columns'}
									rowLoading={(row, index) => {
										return find(row, 'id') === this.props.clickedArticleId;
									}}
									rowLoadingComponent={(
										<div className={'container-dashboard-body-table-row-loading-component'}>
											<Loading size={"small-spinner"} color={"blue"}/>
											<div style={{marginLeft: 8}}>Carregando Artigo</div>
										</div>
									)}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	// Custom component render functions
}

// Redux reducer variables
const mapStateToProps = store => ({
	loadingPending: store.dashboardReducer.loadingPending,
	loadingScheduled: store.dashboardReducer.loadingScheduled,
	pendingArticles: store.dashboardReducer.pendingArticles,
	scheduledArticles: store.dashboardReducer.scheduledArticles,
	clickedArticleId: store.dashboardReducer.clickedArticleId,
});

// Redux dispatch functions
const mapFunctionsToProps = {
	dispatchOnDashboardGetPendingArticles,
	dispatchOnDashboardGetPendingArticlesSuccess,
	dispatchOnDashboardGetPendingArticlesFailure,
	dispatchOnDashboardGetScheduledArticles,
	dispatchOnDashboardGetScheduledArticlesSuccess,
	dispatchOnDashboardGetScheduledArticlesFailure,
	dispatchOnCreateArticlesSetArticleToEditChanged,
	dispatchOnDashboardClickedArticleIdChanged
};

// Redux Connect function to utilize its functionality
export default Connect(mapStateToProps, mapFunctionsToProps)(withTranslation("translations")(Dashboard));
